<template>
  <div class="main">
    <div v-if="!loading">
      <h1 style="margin-top: 0px;">Angebot in Baustelle übertragen</h1>
      <h2>{{ angebot[0].empfaenger }}, {{ angebot[0].bvh }}</h2>
      <table class="toptable">
        <tbody>
         <tr>
            <th scope="row">Bauherr</th>
            <td>
              <input type="text" v-model.trim="baustelle.bauherr" />
            </td>
          </tr> 
          <tr>
            <th scope="row">Bauvorhaben</th>
            <td>
              <input type="text" v-model.trim="angebot[0].bvh" />
            </td>
          </tr>
          <tr>
            <th scope="row">Baustellenadresse</th>
            <td>
              <input type="text" v-model.trim="baustelle.adresse" />
            </td>
          </tr>
           <tr>
            <th scope="row">Auftraggeber</th>
            <td>
              <input type="text" v-model.trim="angebot[0].empfaenger" />
            </td>
          </tr>

          <tr>
            <th scope="row">Rechnungsempfänger</th>
            <td>
              <input type="text" v-model.trim="baustelle.empfaenger" />
            </td>
          </tr>
           <tr>
            <th scope="row">Rechnungsadresse</th>
            <td>
              <input type="text" v-model.trim="angebot[0].rechnungsadresse" />
            </td>
          </tr>
          <tr>
            <th scope="row">PLZ, Ort</th>
            <td>
              <input type="text" v-model.trim="angebot[0].plz" />
            </td>
          </tr>

          <tr>
            <th scope="row">UID Nummer</th>
            <td>
              <input type="text" v-model.trim="baustelle.uid" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragssumme</th>
            <td>
              <input type="number" v-model.number="angebot[0].angebotssumme" />
            </td>
          </tr>
          <tr>
            <th scope="row">Zahlungskonditionen</th>
            <td>
              <input type="text" v-model.trim="baustelle.zkn" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragsdatum</th>
            <td>
              <input type="date" v-model="angebot[0].angebotsdatum" />
            </td>
          </tr>
          <tr>
            <th scope="row">Auftragsnummer</th>
            <td>
              <input type="text" v-model.trim="baustelle.auftragsnummer" />
            </td>
          </tr>
          <tr>
            <th scope="row">Leistungszeitraum</th>
            <td>
              Beginn:
              <input class="oneline" type="date" v-model="angebot[0].beginn" />Ende:
              <input class="oneline" type="date" v-model="angebot[0].ende" />
            </td>
          </tr>
          <tr>
            <th scope="row">Anmerkungen</th>
            <td>
              <textarea rows="4" cols="100" v-model="baustelle.info"></textarea>
            </td>
          </tr>
           <tr>
            <th scope="row">Angebot erstellt am</th>
            <td>{{angebot[0].createdOn | formatDate}}</td>
          </tr>
          <tr>
            <th scope="row">Angebot erstellt von</th>
            <td>{{angebot[0].userName}}</td>
          </tr>
        </tbody>
      </table>
      <h2>Zahlungsplan</h2>
      <table class="zp">
        <tbody>
          <tr class="table-head">
            <th>TR</th>
            <th>Datum</th>
            <th>RG NR</th>
            <th>Leistungsstand</th>
            <th>Rechnungsbetrag</th>
            <th>+20% Mwst</th>
            <th>Verrechnet</th>
            <th>Bezahlt</th>
            <th>Summe bezahlt</th>
          </tr>
          <tr v-for="row in rows" v-bind:key="row.id">
            <td>TR {{ row.TR }}</td>
            <td>
              <input type="date" v-model.trim="row.datum" />
            </td>
            <td>
              <input type="text" v-model.trim="row.rgnr" />
            </td>
            <td>
              <input type="number" v-model.number="row.leistungsstand" />
            </td>
            <td>
              <input type="number" v-model.number="row.rechnungsbetrag" />
            </td>
            <td
              class="dynamic"
            >{{(row.rechnungsbetrag * 0.2 + row.rechnungsbetrag).toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2})}}</td>
            <td>
              <input type="checkbox" v-model="row.verrechnet" />
            </td>
            <td>
              <input type="checkbox" v-model="row.bezahlt" />
            </td>
            <td>
              <input type="number" v-model.number="row.summe" />
            </td>
          </tr>
        </tbody>
      </table>

       <div class="controls">
           <div>
            <button 
              class="button" 
              @click="autoZP" 
              :class="{disabled : baustelle.auftragssumme == 0 || baustelle.beginn == null || baustelle.ende == ''}">
                Zahlungsplan automatisch erstellen
            </button>
          </div>

          <div class="row-buttons">
            <button @click="addRow" class="row-button">+</button>
            <div v-if="rows.length > 1">
              <button @click="removeRow" class="row-button">-</button>
            </div>
          </div>

        </div>

      <div>
        <h2>To Do</h2>
        <table>
            <tr>
            <td>Vorankündigung</td>
            <td><input type="checkbox" v-model="angebot[0].vorankuendigung"></td>
          </tr>
          <tr>
            <td>Unterlage für spätere Arbeiten</td>
            <td><input type="checkbox" v-model="angebot[0].ufa"></td>
          </tr>
          <tr>
            <td>Pläne</td>
            <td><input type="checkbox" v-model="angebot[0].plaene"></td>
          </tr>
          <tr>
            <td>Firmen</td>
            <td><input type="checkbox" v-model="angebot[0].firmen"></td>
          </tr>
          <tr>
            <td>BZP</td>
            <td><input type="checkbox" v-model="angebot[0].bzp"></td>
          </tr>
          <tr>
            <td>SiGe</td>
            <td><input type="checkbox" v-model="angebot[0].sige"></td>
          </tr>
        </table>
      </div>
      

      <div class="buttons">
        <button class="button btn-edit" @click="saveBst">Als Baustelle Speichern</button>
        <button class="button btn-edit" @click="goPrintAngebot">Angebot Drucken</button>
        <button v-if="!angebot[0].nichtBeauftragt" class="button btn-edit" @click="updateAngebot">Absage</button>
        <button class="button btn-edit" @click="exit">Abbrechen</button>
        <button class="button btn-edit warn" @click="deleteBst">Angebot Löschen</button>
      </div>
    </div>
    <div v-else> Loading...</div>
  </div>
</template>

<script>
const fb = require("../fbConfig");
import moment from "moment";
import router from "../router/index";
import { mapState } from "vuex";

export default {
  name: "EditAngebot",
  data() {
    return {
      angebot: [],
      loading: true,
      baustelle: {
        bauherr: "",
        bvh: "",
        adresse: "",
        auftraggeber: "",
        empfaenger: "",
        rechnungsadresse: "",
        plz: "",
        uid: "",
        auftragssumme: 0,
        zkn: "",
        auftragsdatum: "",
        auftragsnummer: "",
        beginn: "",
        ende: "",
        info: ""
      },
      rows: [
        {
          TR: 1,
          id: 1,
          datum: "",
          rgnr: "",
          leistungsstand: "",
          rechnungsbetrag: 0,
          bezahlt: false,
          verrechnet: false,
          summe: 0
        }
      ]
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"])
  },
  methods: {
    addRow() {
      let nextRow = this.rows[this.rows.length - 1].TR + 1;
      this.rows.push({
        TR: nextRow,
        id: nextRow,
        datum: "",
        rgnr: "",
        leistungsstand: "",
        rechnungsbetrag: 0,
        bezahlt: false,
        summe: 0
      });
    },
    removeRow() {
      this.rows.pop();
    },
    autoZP() {
      this.rows = []
      const durationMonths = moment(this.angebot[0].ende).diff(moment(this.angebot[0].beginn), 'months', true)
      
      if (durationMonths < 8) {
        this.rows.push({
          TR: 'SR',
          id: 1,
          datum: moment(this.angebot[0].ende).add(1, 'months').endOf('month').format('YYYY-MM-DD'),
          rgnr: '',
          leistungsstand: '',
          rechnungsbetrag: this.angebot[0].angebotssumme,
          bezahlt: false,
          summe: 0
        })
      } else {
        const numTRs = Math.ceil(durationMonths / 5)
        const sumTRs = this.angebot[0].angebotssumme / numTRs
        const sumTRsRounded = Math.ceil(sumTRs / 50) * 50

        let trs = []

        for (let index = 0; index < numTRs; index++) {
          trs.push({
            TR: index + 1,
            id: index + 1,
            datum: moment(this.angebot[0].beginn).add(5 * (index + 1), 'months').endOf('month').format('YYYY-MM-DD'),
            rgnr: '',
            leistungsstand: '',
            rechnungsbetrag: sumTRsRounded,
            bezahlt: false,
            summe: 0
          })
        }

        const sr = trs.pop()
        sr.TR = 'SR'
        sr.rechnungsbetrag = this.angebot[0].angebotssumme - (sumTRsRounded * trs.length)
        sr.datum = moment(this.angebot[0].ende).add(1, 'months').endOf('month').format('YYYY-MM-DD')
        
        trs.forEach(el => {
          this.rows.push(el)
        })
        this.rows.push(sr)
      }
    },
    saveBst() {
      fb.baustellen
        .add({
          createdOn: new Date(),
          bauherr: this.baustelle.bauherr,
          bvh: this.angebot[0].bvh,
          adresse: this.baustelle.adresse,
          auftraggeber: this.angebot[0].empfaenger,
          empfaenger: this.baustelle.empfaenger,
          rechnungsadresse: this.angebot[0].rechnungsadresse,
          plz: this.angebot[0].plz,
          uid: this.baustelle.uid,
          auftragssumme: this.angebot[0].angebotssumme,
          zkn: this.baustelle.zkn,
          auftragsdatum: this.angebot[0].angebotsdatum,
          auftragsnummer: this.baustelle.auftragsnummer,
          beginn: this.angebot[0].beginn,
          ende: this.angebot[0].ende,
          info: this.baustelle.info,
          userId: this.currentUser.email,
          userName: this.userProfile.name,
          zahlungsplan: this.rows,
          vorankuendigung: this.angebot[0].vorankuendigung ? this.angebot[0].vorankuendigung : false,
          ufa: this.angebot[0].ufa ? this.angebot[0].ufa : false,
          plaene: this.angebot[0].plaene ? this.angebot[0].plaene : false,
          firmen: this.angebot[0].firmen ? this.angebot[0].firmen : false,
          bzp: this.angebot[0].bzp ? this.angebot[0].bzp : false,
          sige: this.angebot[0].sige ? this.angebot[0].sige : false
        })
        .then(ref => {
          fb.angebote
          .doc(this.$route.params.id)
          .delete()
          .then(function() {
            router.push({ name: "Baustellen" });
            console.log("Document successfully deleted!");
          })
          .catch(function(error) {
            console.error("Error removing document: ", error);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    deleteBst() {
      fb.angebote
        .doc(this.$route.params.id)
        .delete()
        .then(function() {
          console.log("Document successfully deleted!");
          router.push({ name: "Angebote" });
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    },
    updateAngebot() {
      fb.angebote
        .doc(this.$route.params.id)
        .update({
          nichtBeauftragt: true
        }).then(()=> {
          console.log("Document successfully updated!");
          router.push({ name: "Angebote" });
        })
        .catch(function(error) {
          console.error("Error removing document: ", error);
        });
    },
    exit() {
      router.push({ name: "Angebote" });
    },
    goPrintAngebot() {
      router.push({name: 'PrintAngebot', id: this.angebot.id})
    }
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("DD.MM.YYYY");
    }
  },
  created() {
    fb.angebote
      .doc(this.$route.params.id)
      .get()
      .then(doc => {
        if (!doc.exists) {
          console.log("No such document!");
          this.loading = false
        } else {
          this.angebot.push(doc.data());
          this.loading = false
        }
      })
      .catch(err => {
        console.log("Error getting document", err);
      });
  }
};
</script>

<style scoped>

.main {
  margin-top: 100px;
  background: #eeeeee;
  padding: 20px;
  border-radius: 20px;
}

table {
  width: 65%;
  text-align: left;
}

.table-head {
  background: #2c3e50;
  color: #eeeeee;
  font-size: 14px;
}

.zp {
  width: 100%;
}

td,
th {
  border: 1px solid rgb(212, 212, 212);
  padding: 0.5rem;
}

.btn-edit {
  margin-top: 5px;
  margin-right: 5px;
  margin-left: 2px;
}

.row-buttons {
  display: flex;
}

.row-button {
  border: none;
  font-size: 1.1em;
  font-weight: bold;
  margin-left: 2px;
  border: 1px solid #999;
  cursor: pointer;
  width: 30px;
  height: 30px;
}

.row-button:hover {
  border: 1px solid #2c3e50;
  color: #fff;
  background: #2c3e50;
}

.controls {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.form-button {
  display: block;
  margin: 10px 0;
}

.warn {
  background-color: rgb(209, 49, 0);
  border: 1px solid rgb(209, 49, 0);
}

.warn:hover {
  border: 1px solid rgb(209, 49, 0);
  background-color: transparent;
  color: rgb(209, 49, 0);
}

input {
  width: 100%;
  box-sizing: border-box;
  padding: 5px;
  border: none;
  outline: none;
  background: transparent;
  font-family: "Avenir";
}

textarea {
  background: transparent;
}

.toptable td:last-of-type {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.zeitraum {
  padding-left: 10px;
  height: 40px;
}

.oneline {
  width: 150px;
  height: 26px;
  padding: 0;
}

.buttons {
  margin-top: 10px;
}
</style>